import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

export function getDatabaseInformation(
    {requiredColumns} = {},
    {ClientID, LocalUserID, FarmID} = {}
) {
    const {_LocalUserID, _ClientID, _FarmID} = getUserApiData({
        ClientID,
        LocalUserID,
        FarmID,
    });
    return invokeApig({
        ...Paths.getDatabaseInformation({
            clientID: _ClientID,
            localUserID: _LocalUserID,
            farmID: _FarmID,
        }),
        queryParams: {
            requiredColumns,
        },
    });
}
